import { createTheme, responsiveFontSizes } from '@mui/material';

import styles from 'styles/export.module.scss';


const theme = responsiveFontSizes(createTheme({
  spacing: 4,
  typography: {
    fontFamily: styles.fontFamily,
  },
  palette: {
    background: {
      default: styles.backgroundColor,
    },
    primary: {
      main: styles.primary,
      contrastText: styles.contrastTextPrimary,
    },
    secondary: {
      main: styles.secondary,
    },
    error: {
      main: styles.danger,
    },
    info: {
      main: styles.info,
    },
    success: {
      main: styles.success,
    },
    text: {
      primary: styles.textPrimary,
      secondary: styles.textSecondary,
      warning: styles.textWarning,
    },
    divider: styles.dividerColor,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: styles.buttonTextWeightFont,
          minHeight: '32px',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: styles.headerColor,
          color: styles.textSecondary,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: styles.textSecondary,
        },
        label: {
          color: styles.textSecondary,
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          color: 'grey',
          '&.Mui-selected': {
            color: 'red',
          },
        },
      },
    },
  },
}));

export default theme;
